// #region Imports
/**
 * To use react functionality
 */
import React from 'react';
/**
 * Use it as a container
*/
import Downshift from 'downshift';
/**
 * to use Icon clock icon
 */
import {IconClock} from '../Icons';
// #endregion

class TimePicker extends React.Component {
    constructor(props) {
        super(props);
        //fetches and store time.
        this.times = this.getTimeList();
    }

    //creates clock time
    getTimeList() {
        //Time interval. Currenty 30 minute.
        const step = 30;
        //store time array
        let times = [];
        let tt = 0;
        //stores array for Ante Meridiem and Post Meridiem
        const periods = ['AM', 'PM'];
        for (let i=0;tt<24*60; i++) {
            let hh = Math.floor(tt/60);
            let mm = (tt%60);
            let val = (((hh==12 || hh==0)?12:hh%12)) + ':' + ('0' + mm).slice(-2) + ' ' + periods[Math.floor(hh/12)];
            times.push({value: val});
            //adds time interval
            tt = tt + step;
        }
        return times;
    }

    render() {
        return(
            <Downshift
                onChange={selection => this.props.handleInput({target: {name: 'time', value: selection.value}})}
                itemToString={time => time ? time.value : ''}
                inputValue={this.props.value}
                defaultHighlightedIndex={24}
            >
                {({ isOpen,
                    getToggleButtonProps,
                    getItemProps,
                    highlightedIndex }) => (
                    <div className="otp-dropdown-wrapper">
                        <button className="dropdown-button" {...getToggleButtonProps()}>
                            <IconClock />
                        </button>
                        { isOpen &&
                            <div className="otp-dropdown">
                                {this.times.map((item, index) => (
                                    // eslint-disable-next-line react/jsx-key
                                    <div
                                        className={highlightedIndex === index ? 'otp-dropdown-item active' : 'otp-dropdown-item'}
                                        {...getItemProps({key:index, index, item })}
                                    >
                                        {item.value}
                                    </div>
                                ))}
                            </div>
                        }

                    </div>
                )}
            </Downshift>
        );
    }
}

export default TimePicker;